





































import { Vue, Component, Prop } from "vue-property-decorator";

import { Evidence } from "@/types";
import EvidencesTable from "@/components/EvidencesTable.vue";
import HistoryButtons from "@/components/HistoryButtons.vue";
import SettingsButton from "@/components/SettingsButton.vue";

@Component({
  components: { SettingsButton, HistoryButtons, EvidencesTable }
})
export default class EvidencesList extends Vue {
  @Prop()
  private evidences!: Evidence[];

  @Prop({ type: Boolean, default: false })
  private editable!: boolean;

  @Prop({ type: Boolean, default: false })
  private draggable!: boolean;

  @Prop({ type: Boolean, default: true })
  private showSettings!: boolean;

  @Prop({ type: Boolean, default: true })
  private showCode!: boolean;

  @Prop({ type: String, default: "ICD10-CM Codes" })
  private title!: string;

  @Prop({ type: Boolean, default: false })
  private showStatistics!: boolean;
}
